<template>
  <LawForm :element="law" :onSubmit="submit"></LawForm>
</template>

<script>
import LawForm from './law-form.vue';
import { busEvent } from '../events/bus';

export default {
  name: 'EditLaw',
  components: {
    LawForm,
  },
  created() {
    this.$store.dispatch('law/getLaw', {
      appId: this.$route.params.appId,
      lawId: this.$route.params.lawId,
    });
  },
  computed: {
    law() {
      return this.$store.state.law.law;
    },
  },
  methods: {
    submit() {
      this.$store.dispatch('law/update', {
        appId: this.$route.params.appId,
        lawId: this.$route.params.lawId,
        body: this.law,
      })
        .then(() => {
          busEvent.$emit('succesPopupCreated', 'Law updated');
        });
    },
  },
};
</script>
